import React from 'react';
import Lottie from 'lottie-react';
import sittingMan from '../../static/lotties/sitting-man.json';
import closedDoor from '../../static/lotties/closed-door.json';
import deliveryBag from '../../static/lotties/delivery-bag.json';

const TheJeetWaySection = () => {
  return (
    <section className='pt-[50px] pb-[80px] bg-[#F2FAFF]'>
      <h6
        className='text-center text-2xl leading-[28px] lg:text-[50px] lg:leading-[60px] font-bold'
        data-aos='slide-up'
        data-aos-delay='100'
        data-aos-duration='800'>
        The <span className='text-kBlue'>Jeet Way</span>{' '}
      </h6>
      <div data-aos='fade-up' data-aos-delay='200' data-aos-duration='800'>
        <p className='max-w-sm px-5 mx-auto mt-3 text-sm text-center text-k2Black lg:px-0 lg:max-w-3xl lg:text-xl'>
          We are committed to providing a solution that enables you to satisfy
          your urgent groceries and deliver them to your doorstep.
        </p>
      </div>
      <section className=' grid lg:grid-cols-3 gap-x-6 gap-y-10 text-center text-[13px] max-w-[260px] lg:max-w-6xl mx-auto  justify-center mt-[88px]'>
        <div
          className='flex flex-col items-center'
          data-aos='fade-up'
          data-aos-delay='250'
          data-aos-duration='800'>
          <div className='flex items-end'>
            <Lottie
              animationData={sittingMan}
              className='object-contain mx-auto w-44 lg:w-72 lg:h-56'
            />
            {/* <StaticImage
              className="w-full h-full mx-auto"
              src={"../../static/images/sitting-man.svg"}
              quality={100}
            /> */}
          </div>
          <h6 className='mt-5 mb-3 text-xl font-bold text-center text-k2Black'>
            Place an order
          </h6>
          <p>Shop from the comfort of your home, with ease</p>
        </div>
        <div
          className='flex flex-col items-center'
          data-aos='fade-up'
          data-aos-delay='300'
          data-aos-duration='800'>
          <div
            className='flex items-end justify-center'
            data-aos='fade-up'
            data-aos-delay='350'
            data-aos-duration='800'>
            <Lottie
              animationData={closedDoor}
              className='object-contain mx-auto w-44 lg:w-72 lg:h-56'
            />
            {/* <StaticImage
              className="w-full h-full mx-auto"
              src={"../../static/images/closed-door.svg"}
              alt="Blue bag"
              quality={100}
            /> */}
          </div>
          <h6 className='mt-5 mb-3 text-xl font-bold text-center text-k2Black'>
            Receive items in 20 minutes or less
          </h6>
          <p>We won’t keep you waiting. We deliver fast</p>
        </div>
        <div
          className='flex flex-col items-center'
          data-aos='fade-up'
          data-aos-delay='450'
          data-aos-duration='800'>
          <div className='flex items-end justify-center'>
            <Lottie
              animationData={deliveryBag}
              className='object-contain mx-auto w-44 lg:w-72 lg:h-56'
            />
            {/* <StaticImage
              className="object-contain w-full h-full mx-auto"
              src={"../../static/images/blue-bag.svg"}
              alt="Blue bag"
              quality={100}
            /> */}
          </div>{' '}
          <h6 className='mt-5 mb-3 text-xl font-bold text-center text-k2Black'>
            Don’t break your bank!
          </h6>
          <p>Enjoy access to items at affordable prices.</p>
        </div>
      </section>
      <div id='coverage-cities'></div>
    </section>
  );
};

export default TheJeetWaySection;
